export const themes = (offerId: string | undefined, cartId: string | undefined, orderId: string | undefined, locationId: string | undefined, region: string | undefined) =>
  ['themes', offerId, cartId, orderId, locationId, region] as const

export const themesV2 = (locationIds: Array<string> | undefined, region: string | undefined) =>
  ['themesV2', locationIds, region] as const
